import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/experiences/register')({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/experiences/register"!</div>;
}
